<div class="video-container" (click)="togglePlay($event)">
    <youtube-player [videoId]="videoId" (stateChange)="onStateChange($event)"></youtube-player>
    <div class="video-player-overlay" *ngIf="!isPlaying"></div>
</div>
